import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { translate } from 'translations/i18n';
import Text from 'components/shared/DesignSystem/SlabTransferPortal/Text';
import { Avatar, Button } from '@companycam/slab-web';
import useTaskListRemoveAssignment from 'components/projects/taskList/assign/hooks/useTaskListRemoveAssignment.js';
import { getFullNameOrEmail } from './helpers';

// #region styled-components
const Item = styled.li`
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_m);
  margin-top: var(--cc_size_spacing_m);
`;
const AvatarContainer = styled.div`
  flex: 1;
  min-width: 1px;
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_s);
`;
const StyledText = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
// #endregion

const AssignedUserItem = ({ assignedUser, taskListId }) => {
  const fullAssignedUserName = getFullNameOrEmail({
    firstName: assignedUser.firstName,
    lastName: assignedUser.lastName,
    emailAddress: assignedUser.emailAddress,
  });
  const { removeTaskListAssignment, loading } = useTaskListRemoveAssignment({
    taskListId,
  });

  return (
    <Item>
      <AvatarContainer>
        <Avatar
          fullName={fullAssignedUserName}
          size="small"
          imageSrc={assignedUser.avatar}
          initials={assignedUser.initials}
          alt={fullAssignedUserName}
        />
        <StyledText size="s" forwardedAs="span" color="default">
          {fullAssignedUserName}
        </StyledText>
      </AvatarContainer>
      <Button
        size="small"
        loading={loading}
        disabled={loading}
        onClick={() =>
          removeTaskListAssignment({
            variables: {
              userId: assignedUser.id,
              taskListId,
            },
          })
        }
      >
        {translate('projects.taskList.assign.unassignButton')}
      </Button>
    </Item>
  );
};

AssignedUserItem.propTypes = {
  assignedUser: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
    initials: PropTypes.string,
    emailAddress: PropTypes.string,
  }).isRequired,
  taskListId: PropTypes.string.isRequired,
};

export default AssignedUserItem;
